import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Fornitori from "@/pages/Fornitori";
import Prodotti from "@/pages/Prodotti";
import ProdottoDettaglio from "@/pages/ProdottoDettaglio";
import Ordini from "@/pages/Ordini";
import Fatture from "@/pages/Fatture";
import Movimentazioni from "@/pages/Movimentazioni";
import MovimentiStorico from "@/pages/MovimentiStorico";
import LogMagazzino from "@/pages/LogMagazzino";
import Impostazioni from "@/pages/Impostazioni";
import Profilo from "@/pages/Profilo";
import PermissionGate from "@/components/PermissionGate";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<PermissionGate perm="dashboard:view" fallback="auto"><Dashboard /></PermissionGate>} />
              <Route path="fornitori" element={<PermissionGate perm="fornitori:view"><Fornitori /></PermissionGate>} />
              <Route path="prodotti" element={<PermissionGate perm="prodotti:view"><Prodotti /></PermissionGate>} />
              <Route path="prodotti/:id" element={<PermissionGate perm="prodotti:view"><ProdottoDettaglio /></PermissionGate>} />
              <Route path="ordini" element={<PermissionGate perm="ordini:view"><Ordini /></PermissionGate>} />
              <Route path="fatture" element={<PermissionGate perm="prodotti:import"><Fatture /></PermissionGate>} />
              <Route path="movimentazioni" element={<PermissionGate perm="movimentazioni:view"><Movimentazioni /></PermissionGate>} />
              <Route path="storico-movimenti" element={<PermissionGate perm="movimentazioni:view"><MovimentiStorico /></PermissionGate>} />
              <Route path="log-magazzino" element={<PermissionGate perm="movimentazioni:view"><LogMagazzino /></PermissionGate>} />
              <Route path="impostazioni" element={<PermissionGate perm="impostazioni:view"><Impostazioni /></PermissionGate>} />
              <Route path="profilo" element={<Profilo />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
